export const footer = {
  copyright: "Copyright",
  faq: "Preguntas frecuentes",
  contact_us: "Contáctanos",
  tos: "Términos de Uso",
  video_policy: "Política de vídeo",
  privacy_policy: "política de privacidad",
  back_to_top: "VOLVER AL PRINCIPIO",
};
